import helpers from '../helpers';

let offsets = [];
let $menuItems = null;

function openMenu() {
	return new Promise((resolve) => {
		$('.js-burger-home').addClass('is-disabled').attr('disabled', true);

		helpers.$html[0].style.overflow = 'hidden';

		helpers.$header.addClass('is-menu-opened');
		// $('.header-home__menu').removeClass('is-hidden');

		setImmediate(() => {
			helpers.$body.css('padding-right', `${helpers.getScrollbarWidth()}px`);
			helpers.$header.css('right', `${helpers.getScrollbarWidth()}px`);
		});

		setTimeout(() => {
			$('.header-home__menu').addClass('is-active');
			$('.js-burger-home').removeClass('is-disabled').attr('disabled', false);

			resolve();
		}, 100);
	});
}

function closeMenu() {
	return new Promise((resolve) => {
		if (!$('.header-home__menu').hasClass('is-active')) {
			resolve();

			return;
		}

		$('.js-burger-home').addClass('is-disabled').attr('disabled', true);

		helpers.$html[0].style.overflow = 'visible';
		helpers.$body.css('padding-right', '');
		helpers.$header.css('right', '');

		helpers.$header.removeClass('is-menu-opened');

		$('.header-home__menu').removeClass('is-active');

		setTimeout(() => {
			// $('.header-home__menu').addClass('is-hidden');
			$('.js-burger-home').removeClass('is-disabled').attr('disabled', false);

			resolve();
		}, 500);
	});
}

function toggleMenu(event) {
	event.preventDefault();
	event.stopPropagation();

	if ($(event.currentTarget).hasClass('is-active')) {
		$(event.currentTarget).removeClass('is-active');
		closeMenu();
	} else {
		$(event.currentTarget).addClass('is-active');
		openMenu();
	}
}

function setActiveItem(i) {
	$menuItems.removeClass('is-active');

	$menuItems.eq(i).addClass('is-active');
}

function checkoutActiveItems(val) {
	let i = offsets.length;
	while (offsets[i - 1] > val) {
		i--;
	}

	setActiveItem(i);
}

function scroll() {
	const val = document.documentElement.scrollTop

	if (helpers.$header.length) {
		if (val > 1) {
			helpers.$header.addClass('fulled');
		} else {
			helpers.$header.removeClass('fulled');
		}
	}

	checkoutActiveItems(val);
}

function init() {
	helpers.$header = $('.header-home');

	$('.js-burger-home').on('click.header', toggleMenu);

	$menuItems = $('.header-home__menu-item');

	$('.header-home__menu-item a').each(function () {
		const id = $(this).attr('href');

		if ($(id).length) {
			offsets.push($(id).offset().top + window.innerHeight / 2);
		}
	});

	helpers.$document
		.on('click.header', (e) => {
			let $container = $('.header-home__menu');

			if ($container.is(e.target) && $container.has(e.target).length === 0 && $container.hasClass('is-active')) {
				closeMenu();
				$('.js-burger-home').removeClass('is-active');
			}
		})
		.on('keyup.header', (e) => {
			if ((e.key === 'Escape' || e.key === 'Esc') && $('.header-home__menu').hasClass('is-active')) {
				closeMenu();
				$('.js-burger-home').removeClass('is-active');
			}
		});
	setActiveItem(0)
	document.addEventListener('scroll', scroll);
}

function destroy() {
	$('.js-burger-home').off('.header-home');
	helpers.$document.off('.header-home');
	document.removeEventListener('scroll', scroll)
	offsets = [];
	$menuItems = null;
}

export default {
	init,
	destroy,
	openMenu,
	closeMenu,
	scroll,
};
